import React from "react";
const WhoisAdapterSummary = ({ dataAdapter }) => {
  const { config } = dataAdapter;
  return /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, "Connect timeout"), /* @__PURE__ */ React.createElement("dd", null, config.connect_timeout, " ms"), /* @__PURE__ */ React.createElement("dt", null, "Read timeout"), /* @__PURE__ */ React.createElement("dd", null, config.read_timeout, " ms"));
};
export default WhoisAdapterSummary;
